module.exports = __webpack_public_path__ + "img/buliding.b169bac4.svg";